module.exports = (function () {
  const HTMLLoaderTab = require('./components/htmlloadertab/hpe.html.loader.tab.controller');

  const COMPONENTS = [
    // Feature: Catalog Components
    // --------------
    require('./pages/productdetailpage/hpe.product.detail.page.controller'),
    require('./components/productlist/base/hpe.productlist.app.controller'),
    require('./components/dynamictabcontainer/hpe.dynamictabcontainer.controller'),
    require('./components/comparetray/hpe.catalog.comparetray.controller'),

    // Feature: Compare Page Components
    // --------------
    require('./components/productcompare/hpe.product.compare.page.controller'),
    require('./components/comparelist/hpe.catalog.comparelist.controller')
  ];

  function initialize() {
    COMPONENTS.forEach((component) => {
      if (typeof component.initialize === 'function') component.initialize();
    });

    // initialize HTMLLoaderTabs in this list if any appear in DOM on page load
    ['overviewComponentContainer', 'specificationsComponentContainer'].forEach(function (tab) {
      const HTMLLoaderTabElement = document.querySelector('.' + tab);
      if (HTMLLoaderTabElement) {
        new HTMLLoaderTab().init({
          queryClassName: tab,
          el: HTMLLoaderTabElement
        });
      }
    });
  }

  // Public methods
  return {
    initialize: initialize
  };
})();
